var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-video-banner',{staticClass:"article__video-banner",attrs:{"video-banner-type":_vm.$options.consts.VIDEO_BANNER_TYPE.ARTICLE,"layout":_vm.layout}})}
var staticRenderFns = []

export { render, staticRenderFns }